import { css } from "@emotion/react";

export const styGiveCard = css`
  border-radius: 4px;
  border: 1px solid #a99d87;
  background-image: linear-gradient(60deg, #ffffff7d 0%, #e2b74426 100%);
  margin: 20px 0;
  padding: 12px 0;

  @media (min-width: 350px) {
    margin: 24px 0;
  }

  .bank-name {
    margin: 0 0 10px;
    font-size: 22px;
    font-weight: 600;

    @media (min-width: 350px) {
      font-size: 18px;
    }
  }

  .bank-number {
    font-size: 14px;
    letter-spacing: 0.7px;
    font-weight: 600;
    margin: 0;

    @media (min-width: 350px) {
      font-size: 16px;
    }
  }

  .bank-owner {
    font-size: 14px;
    letter-spacing: 0.7px;
    margin: 0;

    @media (min-width: 350px) {
      font-size: 16px;
    }
  }
`;
